import React from "react";
import { withI18n } from "react-i18next";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { IAuditionsDto } from "../../../../shared/dto/IKioskDto";
import { IAuditionQuestion } from "../../../../interfaces/IAuditionQuestion";
import { iRootState } from "../../../../store";
import HeaderAuditionInfoSheet from "./HeaderAuditionInfoSheet";
import { client } from "../../../../shared/apiClient";
import styled from "styled-components";
import ProjectDetailsSection from "../ProjectDetailsSection";
import PlaceholderImgSection from "../PlaceholderImgSection";
import ConflictsSection from "../ConflictsSection";
import InformationSection from "../InformationSection";
import ConfirmDetailsSection from "../ConfirmDetailsSection";
import QuestionAnswerSection from "./QuestionAnswerSection";
import { IDropdownObject } from "../../../../interfaces/IDropdownObject";
import { IAuditionAnswer } from "../../../../interfaces/IAuditionAnswer";
import { IActorConflict } from "../../../../interfaces/IActorConflicts";
import {
  IAuditionInfoSheetDto,
  IUnion
} from "../../../../interfaces/IAuditionInfoSheetDto";
import { IMultiSelectOption } from "../../../../interfaces/IMultiSelectOption";
import { isTodayAudition, isPastAudition } from "../../../../helpers";
import { ISessionTemplateInfoSheet } from "../../../../interfaces/ISessionTemplateInfoSheet";
import { IKioskSessionAuditionsDto } from "../../../../interfaces/IKioskSessionAuditionsDto";

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t?: any;
  match: any;
  auditionInfoSheet: any;
  onChange: (auditionInfoSheet: any) => any;
  onSaveAndClose?: () => any;
}

interface IState {
  auditionAnswers: IAuditionAnswer[];
  isReadOnly: boolean;
  roleId: string;
}

class InfoSheetBase extends React.Component<IProps, {}> {
  state: IState = {
    auditionAnswers: [] as IAuditionAnswer[],
    isReadOnly: false,
    roleId: "",
  };
  async componentDidMount() {
    try {
      const {
        infoSheetId,
        scheduleId,
        auditionScheduleId
      } = this.props.match.params;

      await this.props.getSessionTemplateInfoSheetWithAuditionSchedule({scheduleId, auditionScheduleId})
      await this.props.getAuditionQuestions(scheduleId);
      await this.props.getAuditionAnswers(infoSheetId);
      await this.props.getSessionAuditions(scheduleId);
      await this.props.getInfoSheetConflicts(this.getClientId().toString());

      this.setState({ auditionAnswers: this.props.auditionAnswers });
    } catch (error) {
      this.props.history.push("/500");
    }
  }

  componentWillUnmount() {
    this.props.setAuditionInfoSheet({} as IAuditionInfoSheetDto);
  }

  getAuditionInfo = () => {
    const { sessionAuditions, auditionInfoSheet } = this.props;
    const { scheduleId } = this.props.match.params;

    return (
      sessionAuditions &&
      sessionAuditions.auditionsDetails.find(
        (x) =>
          scheduleId &&
          auditionInfoSheet &&
          auditionInfoSheet.auditionScheduleId &&
          x.scheduleId === parseInt(scheduleId) &&
          x.auditionScheduleId === auditionInfoSheet.auditionScheduleId
      )
    );
  };

  getClientId = () => {
    const { sessionAuditions, auditionInfoSheet } = this.props;
    const o =
      sessionAuditions &&
      sessionAuditions.auditionInfoSheets.find(
        (x) =>
          auditionInfoSheet &&
          auditionInfoSheet.auditionScheduleId &&
          x.auditionScheduleId === auditionInfoSheet.auditionScheduleId
      );
    return o && o.clientId ? o.clientId : 0;
  };

  getFn = (auditionInfo: IAuditionsDto) => {
    if (!auditionInfo || !auditionInfo.actor) return "";

    if (auditionInfo.actor.indexOf(" ") > -1)
      return auditionInfo.actor.split(" ")[0];

    return auditionInfo.actor;
  };

  onInfoFieldsChange = (e: any) => {
    let fields = JSON.parse(JSON.stringify(this.props.auditionInfoSheet));
    fields[e.target.name] = e.target.value;
    this.props.onChange(fields);
  };

  // TODO: merge with above
  onConfirmDetailsChange = (field: string, value: boolean) => {
    let fields = JSON.parse(JSON.stringify(this.props.auditionInfoSheet));
    fields[field] = value;
    this.props.onChange(fields);
  };

  onChangeAnswer = (e: any, answer: IAuditionAnswer) => {
    if (!e || !answer) return;
    answer.answer = e.target.value;

    const { auditionAnswers } = this.state;

    if (
      !answer.auditionAnswerId &&
      !auditionAnswers.find(
        (x) => x.auditionQuestionId === answer.auditionQuestionId
      )
    ) {
      let answers = auditionAnswers;
      answers.push(answer);
      this.setState({ auditionAnswers: answers });
      return;
    }

    let answers = this.state.auditionAnswers.map((a: IAuditionAnswer) => {
      if (a.auditionAnswerId && a.auditionAnswerId === answer.auditionAnswerId)
        return answer;
      return a;
    });

    this.setState({ auditionAnswers: answers });
  };

  onCancelAndClose = async () => {
    this.props.history.push({
      pathname: `/sessionAuditions/${this.props.match.params.scheduleId}`,
      state: {
        showSentToast: false,
      },
    });
  };

  onSaveAndClose = async () => {
    const { auditionAnswers, auditionInfoSheet } = this.props;

    let updatedInfoSheet: { [key: string]: any } = {};
    if (this.props.onSaveAndClose) {
      const newAuditionInfoSheet = await this.props.onSaveAndClose();

      Object.keys(newAuditionInfoSheet).forEach(key => {
        if (auditionInfoSheet[key] === undefined) {
          updatedInfoSheet[key] = newAuditionInfoSheet[key];
        } else {
          updatedInfoSheet[key] = auditionInfoSheet[key];
        }
      });
    } else {
      updatedInfoSheet = auditionInfoSheet;
    }

    await this.props.updateAuditionInfoSheet(updatedInfoSheet as IAuditionInfoSheetDto);

    const answersToAdd = this.getAnswersToAdd(updatedInfoSheet);
    if (answersToAdd.length) {
      await this.props.addAuditionAnswers({
        infoSheetId: updatedInfoSheet.infoSheetId,
        answersToAdd
      });
    }

    let answersToUpdate = auditionAnswers.filter((x) => x.auditionAnswerId);
    if (answersToUpdate.length) {
      await this.props.updateAuditionAnswers({
        infoSheetId: updatedInfoSheet.infoSheetId,
        answersToUpdate
      });
    }

    this.props.history.push({
      pathname: `/sessionAuditions/${this.props.match.params.scheduleId}`,
      state: {
        showSentToast: true,
      },
    });
  };

  getAnswersToAdd = (auditionInfoSheet: any) => {
    const { auditionAnswers } = this.props;

    const answersNoId = auditionAnswers.filter((x) => !x.auditionAnswerId);

    return answersNoId.map((a: IAuditionAnswer) => {
      return {
        ...a,
        infoSheetId: auditionInfoSheet.infoSheetId,
        auditionScheduleId: auditionInfoSheet.auditionScheduleId,
        rosterId: auditionInfoSheet.rosterId
      };
    });
  };

  onDropdownChange = (name: string, o: IDropdownObject) => {
    let fields = JSON.parse(JSON.stringify(this.props.auditionInfoSheet));
    fields[name] = o.value;
    this.props.onChange(fields);
  };

  onMultiSelectChange = (
    name: string,
    lstOptionsSelected: IMultiSelectOption[]
  ) => {
    let fields = JSON.parse(JSON.stringify(this.props.auditionInfoSheet));
    let unions = lstOptionsSelected.map((x: IMultiSelectOption) => {
      return {
        code: x.value && parseInt(x.value),
        description: x.label,
      } as IUnion;
    });
    fields[name] = unions;
    this.props.onChange(fields);
  };

  isTvFilm = () => {
    const { sessionAuditions } = this.props;
    if (!sessionAuditions || !sessionAuditions.bdType) return true;
    const bdtype = sessionAuditions.bdType;
    return bdtype === 1 || bdtype === 0 || bdtype === 4;
  };

  render() {
    const {
      t,
      sessionTemplateInfoSheet,
      sessionAuditions,
      auditionInfoSheet,
      auditionQuestions,
      infoSheetConflicts,
    } = this.props;
    const { scheduleId } = this.props.match.params;

    const auditionInfo = this.getAuditionInfo();

    const clientId = this.getClientId();

    const fn = this.getFn(auditionInfo);

    const breadCrumbList = [
      {
        label: t("Scheduling"),
        to: `${client.api.paths.domain}/castingworkbook/directors/schedulelist.asp`,
      },
      { label: t("Kiosk"), to: "/", relative: true },
      {
        label: `${
          sessionTemplateInfoSheet && sessionTemplateInfoSheet.projectName
            ? sessionTemplateInfoSheet.projectName
            : ""
        } ${auditionInfo && auditionInfo.session ? auditionInfo.session : ""}`,
        to: `/castingworkbook/kiosk/sessionAuditions/${scheduleId}`,
      },
      {
        label: `${
          auditionInfo && auditionInfo.actor ? auditionInfo.actor : ""
        } Info sheet`
      },
    ];

    let pastAudition = false;
    if (
      sessionAuditions &&
      sessionAuditions.auditionsDetails &&
      sessionAuditions.auditionsDetails.length > 0
    ) {
      pastAudition = isPastAudition(
        sessionAuditions.auditionsDetails[
          sessionAuditions.auditionsDetails.length - 1
        ].auditionTime,
        sessionAuditions.auditionDate
      ) && !isTodayAudition(sessionAuditions.auditionDate);
    }

    return (
      <>
        <HeaderAuditionInfoSheet
          actor={auditionInfo && auditionInfo.actor ? auditionInfo.actor : ""}
          breadCrumbList={breadCrumbList}
          onSaveAndClose={this.onSaveAndClose}
          onCancelAndClose={this.onCancelAndClose}
          pastAudition={pastAudition}
        />
        <Wrapper>
          <ContentBox>
            <ContentHeader>
              <ContentTitle>{t("AUDITION INFO SHEET")}</ContentTitle>
            </ContentHeader>
            <div className="row">
              <div className="col-6 shift-left-15">
                <div className="col-12">
                  <ProjectDetailsSection
                    sessionTemplateInfoSheet={sessionTemplateInfoSheet}
                  />
                </div>
                <div className="col-12">
                  <ConflictsSection
                    sessionTemplateInfoSheet={sessionTemplateInfoSheet}
                    isReadOnly={pastAudition}
                    setDefault={true}
                    conflicts={sessionAuditions && sessionAuditions.conflicts}
                    auditionInfoSheet={auditionInfoSheet}
                    infoSheetConflicts={infoSheetConflicts}
                    isTvFilm={this.isTvFilm()}
                    handleChange={this.onInfoFieldsChange}
                  />
                </div>
              </div>
              <div className="col-6">
                <PlaceholderImgSection
                  isReadOnly={pastAudition}
                  clientId={clientId}
                  fn={fn}
                />
              </div>
              <div className="col-12">
                <InformationSection
                  sessionTemplateInfoSheet={sessionTemplateInfoSheet}
                  auditionInfoSheet={auditionInfoSheet}
                  isReadOnly={pastAudition}
                  handleChange={this.onInfoFieldsChange}
                  onDropdownChange={this.onDropdownChange}
                  onMultiSelectChange={this.onMultiSelectChange}
                  isTvFilm={this.isTvFilm()}
                />
              </div>
              {Boolean(auditionQuestions.length) && (
                <div className="col-12">
                  <QuestionAnswerSection
                    auditionQuestions={auditionQuestions}
                    onChangeAnswer={this.onChangeAnswer}
                    auditionAnswers={this.state.auditionAnswers}
                    pastAudition={pastAudition}
                  />
                </div>
              )}
              <div className="col-12">
                <ConfirmDetailsSection
                  isReadOnly={pastAudition}
                  auditionInfoSheet={auditionInfoSheet}
                  handleChange={this.onConfirmDetailsChange}
                />
              </div>
            </div>
          </ContentBox>
        </Wrapper>
      </>
    );
  }
}

interface StateProps {
  sessionTemplateInfoSheet: ISessionTemplateInfoSheet;
  auditionQuestions: IAuditionQuestion[];
  auditionAnswers: IAuditionAnswer[];
  sessionAuditions: IKioskSessionAuditionsDto;
  infoSheetConflicts: IActorConflict[];
}

function mapStateToProps(state: iRootState): StateProps {
  return {
    sessionTemplateInfoSheet: state.kiosk.sessionTemplateInfoSheet,
    auditionQuestions: state.kiosk.auditionQuestions,
    sessionAuditions: state.kiosk.sessionAuditions,
    auditionAnswers: state.kiosk.auditionAnswers,
    infoSheetConflicts: state.kiosk.infoSheetConflicts,
  };
}

interface DispatchProps {
  addAuditionAnswers: ({ infoSheetId, answersToAdd }: any) => void;
  getSessionTemplateInfoSheetWithAuditionSchedule: (id: any) => void;
  getAuditionQuestions: (id: string) => void;
  getAuditionAnswers: (id: string) => void;
  addAuditionQuestions: (questions: IAuditionQuestion[]) => void;
  updateAuditionQuestions: (questions: IAuditionQuestion[]) => void;
  updateAuditionAnswers: ({ infoSheetId, answersToUpdate }: any) => void;
  getSessionAuditions: (id: string) => void;
  sendInfoSheet: (id: string) => void;
  getInfoSheetConflicts: (id: string) => void;
  updateAuditionInfoSheet: (auditionInfoSheet: IAuditionInfoSheetDto) => void;
  setAuditionInfoSheet: (auditionInfoSheet: IAuditionInfoSheetDto) => any;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    addAuditionAnswers: dispatch.kiosk.addAuditionAnswers,
    getSessionTemplateInfoSheetWithAuditionSchedule: dispatch.kiosk.getSessionTemplateInfoSheetWithAuditionSchedule,
    getAuditionQuestions: dispatch.kiosk.getAuditionQuestions,
    getAuditionAnswers: dispatch.kiosk.getAuditionAnswers,
    addAuditionQuestions: dispatch.kiosk.addAuditionQuestions,
    updateAuditionQuestions: dispatch.kiosk.updateAuditionQuestions,
    updateAuditionAnswers: dispatch.kiosk.updateAuditionAnswers,
    getSessionAuditions: dispatch.kiosk.getSessionAuditions,
    sendInfoSheet: dispatch.kiosk.sendInfoSheet,
    getInfoSheetConflicts: dispatch.kiosk.getInfoSheetConflicts,
    updateAuditionInfoSheet: dispatch.kiosk.updateAuditionInfoSheet,
    setAuditionInfoSheet: dispatch.kiosk.setAuditionInfoSheet
  };
}

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(InfoSheetBase))
);

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: ${(p) => p.theme.kiosk.backgroundColor};

  .cwb-table-wrapper {
    max-width: 1040px;
    border: 1px solid #e7e7f0 !important;
    box-shadow: 0 2px 4px 0 #e0e0e0 !important;
    border-radius: 4px;
  }
`;

const ContentBox = styled.div`
  background: white;
  padding: 24px;
  width: 100%;
  min-height: 70vh;
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  margin: 40px auto;
  overflow-x: hidden;
  overflow-y: hidden;
`;

const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
  margin-right: 2px;
`;

const ContentTitle = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;
`;
